export default __webpack_public_path__ + "static/media/p2023-20.e179c540.jpeg";